import { render, staticRenderFns } from "./25.vue?vue&type=template&id=5364a0b4&scoped=true&"
import script from "./25.vue?vue&type=script&lang=js&"
export * from "./25.vue?vue&type=script&lang=js&"
import style0 from "./25.vue?vue&type=style&index=0&id=5364a0b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5364a0b4",
  null
  
)

export default component.exports